import {handleValidationChange} from '../CommonValidation';

export const validateSchedule = (details, schedules, setIsError) => {
    var isValid = true;

    if(details.branch_id === "" || details.branch_id === undefined || details.branch_id === null) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }

    if(details.type === "single" && (details.date === "" || details.date === undefined)) {
        handleValidationChange("date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("date", false, setIsError);
    }
    
    if(details.type === "multiple" && (details.date_from === "" || details.date_from === undefined)) {
        handleValidationChange("date_from", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("date_from", false, setIsError);
    }

    if(details.type === "multiple" && (details.date_to === "" || details.date_to === undefined)) {
        handleValidationChange("date_to", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("date_to", false, setIsError);
    }

    if(schedules.length < 1) {
        handleValidationChange("schedules", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("schedules", false, setIsError);
    }

    schedules.map((data) => {
        if(data.employee_id === "" || data.employee_id === null || data.employee_id === undefined) {
            handleValidationChange("employee_id", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("employee_id", false, setIsError);
        }
        
        if(data.time_start === "" || data.time_start === null || data.time_start === undefined) {
            handleValidationChange("time_start", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("time_start", false, setIsError);
        }

        if(data.time_end === "" || data.time_end === null || data.time_end === undefined) {
            handleValidationChange("time_end", true, setIsError);
            isValid=false;
        } else { 
            if(parseFloat(data.hours_total) < 0){
                handleValidationChange("time_end_validation", true, setIsError);
                isValid=false;
            } else {
                handleValidationChange("time_end_validation", false, setIsError);
                handleValidationChange("time_end", false, setIsError);
            }
        }

        if((data.break_time !== "" && data.break_time !== null && data.break_time !== undefined) 
            && (data.break_end === "" || data.break_end === null || data.break_end === undefined)) {
            handleValidationChange("break_end", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("break_end", false, setIsError);
        }

        if(parseFloat(data.break_hours) < 0){
            handleValidationChange("break_end_validation", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("break_end_validation", false, setIsError);
        }
        
    })



    return isValid
  
}
